import apiConfig from "../../config/apiConfig";
import { END_POINT, FACEBOOK_USER_TYPE, PAGE_FACEBOOK_TYPE } from "../constants";
import { URL } from "../../routers/constants";
import { setError } from "./errorAction";
import { objToQueryString } from "../../services/helpers/Helper";
import { setPage } from "./pageAction";
import { hideLoading, showLoading } from "./loadingAction";
import { loadAllData } from "./conversationAction";

export const fetchPageFacebook = (user, navigate) =>
   async (dispatch) => {
      dispatch({
         type: FACEBOOK_USER_TYPE.SET,
         payload: user
      });

      const params = {
         fb_user_token: user.accessToken,
         clientType: '',
         revision: '',
         languageCode: '',
         countryCode: '',
         timestamp: new Date().getTime()
      }

      const qs = objToQueryString(params);
      const endPoint = `${END_POINT.LIST_PAGES}?${qs}`;
      dispatch(showLoading());

      apiConfig.get(endPoint).then((response) => {
         const { data } = response;
         dispatch({
            type: PAGE_FACEBOOK_TYPE.FETCH,
            payload: data,
         });
         navigate(URL.CHANNEL_FACEBOOK);
      }).catch((error) => {
         dispatch(setError(error.message));
      }).finally(() => {
         dispatch(hideLoading());
      })
   };


export const connectPageFacebook = (page, callbackSuccess = undefined, callbackError = undefined) =>
   async (dispatch) => {

      const params = {
         fb_page_id: page.social_id,
         clientType: '',
         revision: '',
         languageCode: '',
         countryCode: '',
         timestamp: new Date().getTime()
      }
      const qs = objToQueryString(params);
      const endPoint = `${END_POINT.CONNECT_PAGE}?${qs}`
      apiConfig.post(endPoint).then((response) => {
         dispatch(setPage(page));
         dispatch(loadAllData(page.social_id));
         if (callbackSuccess) {
            callbackSuccess();
         }
      }).catch((error) => {
         if (callbackError) {
            callbackError();
         }
         dispatch(setError(error.message))
      })
   }
